import type { AppFieldExtendedReactFormApi } from '@tanstack/react-form';
import { createContext, useContext } from 'react';

import type { SharedLinkFormDefaults } from '../model';

export type SharedLinkForm = AppFieldExtendedReactFormApi<
  SharedLinkFormDefaults,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any
>;

const SharedLinkFormContext = createContext<SharedLinkForm | null>(null);

type ProviderProps = {
  form: SharedLinkForm;
  children: React.ReactNode;
};

export function SharedLinkFormProvider({ form, children }: ProviderProps) {
  return (
    <SharedLinkFormContext.Provider value={form}>
      {children}
    </SharedLinkFormContext.Provider>
  );
}

export function useSharedLinkForm() {
  const form = useContext(SharedLinkFormContext);

  if (!form) {
    throw new Error('SharedLinkFormContext is required');
  }

  return form;
}
